<app-access-item [icon]="'/assets/icons/globe-outline.svg'" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>Permissions</app-access-item-header>
  <app-access-item-cta>
    <app-gallery-share-context
      itemCta
      [currentAccessLevel]="publicAccessLevel()"
      [accessLevels]="publicAccessLevels"
      [mode]="'link'"
      (onChange)="changePublicAccessLevel($event)"
      [disabled]="!isTeamMember() || !galleryPermissions().can_edit"
      [type]="'gallery'"
    ></app-gallery-share-context>
  </app-access-item-cta>
</app-access-item>
